export default __webpack_public_path__ + "0ff132c586f87332d73a4de8cd7de787.webp";